module.exports = __webpack_public_path__ + "img/logo-white.9a06d495.svg";